import React, { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';

import ModalCCV from "../ModalCCV";
import { addToast } from "../Notification";

import { toReal, validCheckout, checkCardBrand } from '../../utils';
import * as image from '../../assets';
import './styles.css'
import { Collapse } from 'reactstrap';
import { getVoucheByClass } from '../../providers/course';

function Checkout({ 
    disabled, disableSameTaxpayer, price, 
    transaction, taxpayer, handleUpdate,
    hasVoucher, courseClass, updateCurrentVoucher
}) {
    const [payload, setPayload] = useState({
        holder_name: "",
        exp_month: "",
        exp_year: "",
        number: "",
        cvc: "",
        amount: 0,
        installment_number: "1",
        brand: "",
        holder_taxpayer: "",
        voucher_id: null
    });
    const [isSameTaxpayer, setIsSameTaxpayer] = useState(false);
    const [modal, setModal] = useState(false);
    const [showVoucherInput, setShowVoucherInput] = useState(false);
    const [voucherName, setVoucherName] = useState("");
    const [voucher, setVoucher] = useState(null);

    useEffect(() => {
        if (price) {
            setPayload({ ...payload, amount: price });
        } else if (transaction) {
            setPayload({
                ...payload,
                amount: transaction.value,
                installment_number: transaction.installments > 0 ? transaction.installments : '1'
            })
        }
    }, [price, transaction]);

    useEffect(() => {
        updateCurrentVoucher(voucher);
    }, [voucher])

    const handleChangeValue = (field, value) => {
        return setPayload({ ...payload, [field]: value });
    }

    const handleTriggerModal = () => setModal(!modal);

    const formatMonth = (value) => {
        const _month = value < 10 ? "0" + value : value.toString();
        return _month
    }

    const getVoucher = async () => {
        try {
            const _payload = { 
                name: voucherName, 
                class: courseClass ? courseClass.id : transaction.inscription.course_class.id
            }
            const response = await getVoucheByClass(_payload);
            setVoucher(response);

            let currentAmount = Number(payload.amount);
            if(Number(response.amount) > 0) {
                currentAmount = currentAmount - Number(response.amount);
            } else if (Number(response.percent > 0)) {
                currentAmount = currentAmount - (currentAmount * (Number(response.percent) / 100))
            }

            setPayload({ ...payload, amount: currentAmount, voucher_id: response.id });
            setVoucherName("");
            addToast("success", "Cupom Aplicado")
        } catch (error) {
            addToast("error", "Erro", error.message);
        }
    }

    const removeVoucher = async () => {
        if(price) {
            setPayload({ ...payload, amount: price, voucher_id: null });
            setVoucher(null);
            setVoucherName("");
        } else if (transaction) {
            setPayload({ ...payload, amount: transaction.value, voucher_id: null });
            setVoucher(null);
            setVoucherName("");
        }
    }
    
    const handleSubmit = (event) => {
        event.preventDefault();

        const checkCard = checkCardBrand(payload.number);
        var newTaxpayer = '';
        if (isSameTaxpayer && transaction) {
            newTaxpayer = transaction.inscription.trainee.taxpayer.replace("-", "")
        } else if(isSameTaxpayer && disableSameTaxpayer){
            newTaxpayer = disableSameTaxpayer.taxpayer.replace("-", "")
        } else if (isSameTaxpayer) {
            newTaxpayer = taxpayer.replace("-", "")
        } else {
            newTaxpayer = payload.holder_taxpayer.replace("-", "")
        }

        let checkoutPayload = {
            ...payload,
            exp_month: formatMonth(payload.exp_month),
            brand: checkCard ? checkCard : "",
            holder_taxpayer: newTaxpayer
        }

        let valid = validCheckout(checkoutPayload);
        if (!valid.status) {
            return addToast("error", "Erro", valid.message);
        }

        return handleUpdate(checkoutPayload);
    }

    const _CURRENT_YEAR = new Date().getFullYear();
    
    return (
        <>
            <form autoComplete='off' onSubmit={transaction ? (event) => handleSubmit(event) : disabled ? () => { } : (event) => handleSubmit(event)} className="">
                <div className="box">
                    {/* <CurrencyInput
                        prefix='R$ '
                        onChangeEvent={(event, mask, value) => {
                            handleChangeValue('amount', value)
                        }}
                        value={payload.amount}
                        disabled
                    /> */}
                    <input
                        type='tel'
                        placeholder="Número do Cartão"
                        onBlur={({ target }) => handleChangeValue('number', target.value)}
                    />
                    <input
                        placeholder="Nome do Titular do Cartão"
                        type='text'
                        onBlur={({ target }) => handleChangeValue('holder_name', target.value)}
                    />
                    {!isSameTaxpayer && (
                        <InputMask
                            placeholder="CPF do Titular do Cartão"
                            mask="999999999-99"
                            type="tel"
                            onChange={({ target }) => handleChangeValue('holder_taxpayer', target.value)}
                        />
                    )}
                    <fieldset className="inputGroup">
                        <input
                            id="isSameTaxpayer"
                            name="isSameTaxpayer"
                            type="checkbox"
                            value={isSameTaxpayer}
                            onChange={({ target }) => setIsSameTaxpayer(target.checked)}
                        />
                        <label htmlFor="isSameTaxpayer">Mesmo CPF do Treinando</label>
                    </fieldset>

                    {hasVoucher ? <div id="voucher-container">
                        <div id="voucher-toggler-container" onClick={() => setShowVoucherInput(!showVoucherInput)}>
                            <div>
                                <img src={image.VOUCHER_ICON} id="voucher-icon" alt='voucher-icon'/>
                                <span>Tem um cupom de desconto?</span>
                            </div>
                            <img src={image.ARROW_DOWN_ICON} id="arrow-down-icon" alt='arrow-down-icon'/>
                        </div>
                        <Collapse isOpen={showVoucherInput}>
                            <div id="voucher-form">
                                <input
                                    id="voucher-input"
                                    value={voucherName}
                                    type='text'
                                    onChange={({ target }) => setVoucherName(target.value)}
                                />
                                {voucher ? 
                                    <button type='button' id="voucher-button-cancel" onClick={removeVoucher}>Remover</button> : 
                                    <button type='button' id="voucher-button-confirm" onClick={getVoucher}>Aplicar</button> 
                                }
                            </div>
                            {voucher ? <p id="voucher-confirm">Você recebeu um desconto de {Number(voucher.amount) > 0 ? toReal(Number(voucher.amount)) : `${voucher.percent}%`}!</p> : null }
                        </Collapse>
                    </div> : null}
                    
                    <div className="row-input">
                        <div className="customSelectContainer">
                            <select
                                style={{ marginRight: 10 }}
                                className="customSelect"
                                onChange={({ target }) => handleChangeValue('exp_month', target.value)}
                            >
                                <option selected disabled hidden>MÊS</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                                <option>9</option>
                                <option>10</option>
                                <option>11</option>
                                <option>12</option>
                            </select>
                            <select
                                className="customSelect"
                                onChange={({ target }) => handleChangeValue('exp_year', target.value)}
                            >
                                <option selected disabled hidden>ANO</option>
                                {Array.from(Array(15), (_, index) => <option key={_CURRENT_YEAR + index} value={_CURRENT_YEAR + index}>{_CURRENT_YEAR + index}</option>)}
                            </select>
                            <div className="cvvInput">
                                <input
                                    type="tel"
                                    placeholder="CVV"
                                    maxLength={4}
                                    onBlur={({ target }) => handleChangeValue('cvc', target.value)}
                                />
                                <img onClick={() => setModal(true)} src={image.INFOR} id="infor-icon" />
                            </div>
                        </div>
                    </div>

                    <select
                        className="customSelect"
                        onChange={({ target }) => handleChangeValue('installment_number', target.value)}
                    >
                        {transaction ? <>
                            {transaction.installments >= 1 || transaction.installments === "" || transaction.installments === "0" ? <option value={1} selected={transaction.installments === '1' ? true : false}>
                                {payload.amount ? `1x de ${toReal(parseFloat(payload.amount))}` : `1x de ${toReal(parseFloat(transaction.value))}`}
                            </option> : null}
                            {transaction.installments >= 2 || transaction.installments === "" || transaction.installments === "0" ? <option value={2} selected={transaction.installments === '2' ? true : false}>
                                {payload.amount ? `2x de ${toReal((payload.amount / 2))}` : `2x de ${toReal((transaction.value / 2))}`}
                            </option> : null }
                            {transaction.installments >= 3 || transaction.installments === "" || transaction.installments === "0" ? <option value={3} selected={transaction.installments === '3' ? true : false}>
                                {payload.amount ? `3x de ${toReal((payload.amount / 3))}` : `3x de ${toReal((transaction.value / 3))}`}
                            </option> : null }
                            {transaction.installments >= 4 || transaction.installments === "" || transaction.installments === "0" ? <option value={4} selected={transaction.installments === '4' ? true : false}>
                                {payload.amount ? `4x de ${toReal((payload.amount / 4))}` : `4x de ${toReal((transaction.value / 4))}`}
                            </option> : null }
                            {transaction.installments >= 5 || transaction.installments === "" || transaction.installments === "0" ? <option value={5} selected={transaction.installments === '5' ? true : false}>
                                {payload.amount ? `5x de ${toReal((payload.amount / 5))}` : `5x de ${toReal((transaction.value / 5))}`}
                            </option> : null }
                            {transaction.installments >= 6 || transaction.installments === "" || transaction.installments === "0" ? <option value={6} selected={transaction.installments === '6' ? true : false}>
                                {payload.amount ? `6x de ${toReal((payload.amount / 6))}` : `6x de ${toReal((transaction.value / 6))}`}
                            </option> : null }
                            {transaction.installments >= 7 || transaction.installments === "" || transaction.installments === "0" ? <option value={7} selected={transaction.installments === '7' ? true : false}>
                                {payload.amount ? `7x de ${toReal((payload.amount / 7))}` : `7x de ${toReal((transaction.value / 7))}`}
                            </option> : null }
                            {transaction.installments >= 8 || transaction.installments === "" || transaction.installments === "0" ? <option value={8} selected={transaction.installments === '8' ? true : false}>
                                {payload.amount ? `8x de ${toReal((payload.amount / 8))}` : `8x de ${toReal((transaction.value / 8))}`}
                            </option> : null }
                            {transaction.installments >= 9 || transaction.installments === "" || transaction.installments === "0" ? <option value={9} selected={transaction.installments === '9' ? true : false}>
                                {payload.amount ? `9x de ${toReal((payload.amount / 9))}` : `9x de ${toReal((transaction.value / 9))}`}
                            </option> : null }
                            {transaction.installments >= 10 || transaction.installments === "" || transaction.installments === "0" ? <option value={10} selected={transaction.installments === '10' ? true : false}>
                                {payload.amount ? `10x de ${toReal((payload.amount / 10))}` : `10x de ${toReal((transaction.value / 10))}`}
                            </option> : null }
                            {transaction.installments >= 11 ? <option value={11} selected={transaction.installments === '11' ? true : false}>
                                {payload.amount ? `11x de ${toReal((payload.amount / 11))}` : `11x de ${toReal((transaction.value / 11))}`}
                            </option> : null }
                            {transaction.installments >= 12 ? <option value={12} selected={transaction.installments === '12' ? true : false}>
                                {payload.amount ? `12x de ${toReal((payload.amount / 12))}` : `12x de ${toReal((transaction.value / 12))}`}
                            </option> : null} 
                        </>
                        : <>
                            <option value={1}>{`1x de ${toReal(parseFloat(payload.amount))}`}</option>
                            <option value={2}>{`2x de ${toReal((payload.amount / 2))}`}</option>
                            <option value={3}>{`3x de ${toReal((payload.amount / 3))}`}</option>
                            <option value={4}>{`4x de ${toReal((payload.amount / 4))}`}</option>
                            <option value={5}>{`5x de ${toReal((payload.amount / 5))}`}</option>
                            <option value={6}>{`6x de ${toReal((payload.amount / 6))}`}</option>
                            <option value={7}>{`7x de ${toReal((payload.amount / 7))}`}</option>
                            <option value={8}>{`8x de ${toReal((payload.amount / 8))}`}</option>
                            <option value={9}>{`9x de ${toReal((payload.amount / 9))}`}</option>
                            <option value={10}>{`10x de ${toReal((payload.amount / 10))}`}</option>
                        </> }
                    </select>
                </div>
                <div className="confirmButtonContainer">
                    <button 
                    disabled={transaction ? false : disabled} 
                    className="confirm-button">
                        Pagar agora
                    </button>
                </div>
            </form>
            <ModalCCV
                modal={modal}
                triggerModal={handleTriggerModal}
            />
        </>
    );
}

export default Checkout;